import { ViBrandContextApi } from '@api/visibilityIntelligence/models/vi-brand-context.api.model';
import { ViBrandApi } from '@api/visibilityIntelligence/models/vi-brand.api.model';

// Brand and Competitors
export class ViBrandIdentity {
    id?: number;
    brandId?: number;
    name: string;
    nameVariations: string[];
    websites?: string[] = [];
    industry?: string;
    bio?: string;
    additionalContext?: ViBrandContextApi[]; // Additional Information


    constructor(apiModel?: ViBrandApi) {
        if (apiModel) {
            this.constructFromApiModel(apiModel);
        }
    }

    constructFromApiModel(apiModel: ViBrandApi) {
        this.brandId = apiModel.brandIdentityId ? +apiModel.brandIdentityId : undefined;
        this.name = apiModel.primaryName ?? '';
        this.nameVariations = apiModel.nameVariations ?? [];
        this.industry = apiModel.industry ?? '';
        this.bio = apiModel.companyOverview ?? '';
        this.additionalContext = apiModel.additionalContext ?? [];
    }

    toApiModel(): ViBrandIdentity {
        return {
            id: this.id,
            brandId: this.brandId,
            name: this.name,
            nameVariations: this.nameVariations,
            websites: this.websites,
            industry: this.industry,
            bio: this.bio,
            additionalContext: this.additionalContext,
        } as ViBrandIdentity;
    }
}
